export const CampaignBudget = {
  // Open and close Campaign Budget Exceed
  OPEN_CAMPAIGN_BUDGET_EXCEED_MODAL: "OPEN_CAMPAIGN_BUDGET_EXCEED_MODAL",
  CLOSE_CAMPAIGN_BUDGET_EXCEED_MODAL: "CLOSE_CAMPAIGN_BUDGET_EXCEED_MODAL",
};
